import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { Rally } from '@/lib/models/Rally'

@Module
export class PageURLRally extends VuexModule {
    public rally: Rally = new Rally()

    @Mutation
    public updateRally (rally: Rally) {
      this.rally = rally
    }

    @Action({ commit: 'updateRally', rawError: true })
    public async loadRally (rallyId?: number) {
      const urlParams = new URLSearchParams(window.location.search)
      const pageUrlRallyId = parseInt(urlParams.get('rid') ?? '0')
      if (rallyId ?? pageUrlRallyId !== 0) {
        return await Rally.get(rallyId ?? pageUrlRallyId)
      } else {
        return new Rally()
      }
    }
}
